import { Box, Button, CircularProgress } from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'
import { mainButtonStyle } from 'common/styles'
import { SizingContainer } from 'components/SizingContainer'
import { useSessionState } from 'context/Session'

import { SubmitButton as SubmitButtonProps } from './interface'

const SubmitButton = ({
  text,
  onClick,
  variant = 'contained',
}: SubmitButtonProps & DefaultElementProps): JSX.Element => {
  const { isSubmitting, isSubmitted, isSubmitDisabled } = useSessionState()

  const handleClick = (): void => {
    onClick?.(
      {},
      {
        onError: (e) => {
          console.log(e.message)
        },
      }
    )
  }

  return (
    <SizingContainer className="submit-btn-wrap">
      <Box sx={mainButtonStyle.container}>
        <Button
          form="form"
          variant={variant}
          onClick={handleClick}
          type="submit"
          disabled={isSubmitting || isSubmitted || isSubmitDisabled}
          sx={mainButtonStyle.button}
        >
          {Boolean(isSubmitting) && (
            <CircularProgress sx={{ marginRight: '12px', color: 'white' }} size={24} />
          )}
          {text}
        </Button>
      </Box>
    </SizingContainer>
  )
}

export default SubmitButton
